module.exports = __webpack_public_path__ + "static/media/sunday-in-spanish.99e48984.png";